<label class="switch" >
  <input type="checkbox"  [(ngModel)]="value" (change)="onToggle()">
  <span class="slider round">
      <span class="toggle-no" [ngClass]="{'toggle-no-active': !value }" i18n="parameters-accessibility|@@no" >Non</span>
    <span class="toggle-yes" [ngClass]="{'toggle-yes-active': value}" i18n="parameters-accessibility|@@yes" >Oui</span>
  </span>
</label>


// WEBPACK FOOTER //
// ./src/app/element/generic-toggle/generic-toggle.component.html